import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Specials = (props) => {

    const specials = {
        Chinese: {
            tagLine: "There’s Nothing Better than Chinese Leftovers",
            menuData: [
                {
                    title: "Search of life starts with a cup of noodles.",
                    description: "Hakka noodles are Indian-Chinese style noodles made with unleavened refined wheat flour. These are boiled al dente and then stir fried in a Chinese wok with oil, vegetables & soya sauce.",
                    image: "https://img.freepik.com/free-photo/egg-noodle-with-red-roasted-pork-wonton-table_1150-13422.jpg?size=626&ext=jpg"
                },
                {
                    title: "Rice that makes your meal complete",
                    description: "Fried rice is an Asian dish made by stir frying cooked rice in a wok with vegetables, soya sauce and sometimes With meat & eggs as well.",
                    image: "https://img.freepik.com/free-photo/schezwan-fried-rice-masala-szechuan-rice-is-popular-indo-chinese-food-served-plate-bowl-with-chopsticks-selective-focus_466689-74707.jpg?size=338&ext=jpg"
                },
                {
                    title: "I have a Filling I might need more dumplings after this",
                    description: "Dumpling, small mass of leavened dough that is either boiled or steamed and served in soups or stews or with fruit.",
                    image: "https://img.freepik.com/free-photo/chinese-jiaozi-new-year-food_1205-3336.jpg?size=626&ext=jpg"
                },

            ],
            sideMenu: [
                "Hakka Noodles",
                "Fried Rice",
                "Dumplings"
            ]
        },
        Italian: {
            tagLine: "There's nothing more romantic than Italian food.",
            menuData: [
                {
                    title: "It’s difficult not to love our pasta.",
                    description: "Pasta is a type of food made from a mixture of flour, eggs, and water that is formed into different shapes and then boiled. Spaghetti, macaroni, and noodles are types of pasta.",
                    image: "https://img.freepik.com/free-photo/penne-pasta-tomato-sauce-with-chicken-tomatoes-wooden-table_2829-19739.jpg?size=626&ext=jpg"
                },
                {
                    title: "Lasagna: the world's most perfect food!",
                    description: "Lasagna is the name of one of the oldest and best-known pasta shapes. It is usually rectangular or ribbon shaped, thicker than tagliatelle, with numerous local variants.",
                    image: "https://img.freepik.com/free-photo/classic-lasagna-with-bolognese-sauce_2829-11250.jpg?size=626&ext=jpg"
                },
                {
                    title: "All that and a plate of fries.",
                    description: "Some may say French fries are really nothing other than deep fried potatoes, but in order to truly appreciate French fries at their best, there are a number of factors to take into consideration.",
                    image: "https://img.freepik.com/free-photo/crispy-french-fries-with-ketchup-mayonnaise_1150-26588.jpg?size=626&ext=jpg"
                },

            ],
            sideMenu: [
                "Pasta",
                "Lasagne",
                "Chips"
            ]
        },
        "Baked Goods": {
            tagLine: "Come Experience The Taste Of Joy.",
            menuData: [
                {
                    title: "It's sweet, it's fluffy, it's delicious.",
                    description: "Treat your loved ones to a jaw-dropping Eggless Pineapple Pastry Recipe that is outrageously delicious, rich, and decadent.",
                    image: "https://img.freepik.com/free-photo/side-view-fruit-cake-with-vanilla-cream-chocolate-kiwi-orange-strawberry-pineapple-pastries-table_141793-4924.jpg?size=626&ext=jpg"
                },
                {
                    title: "Let us eat cake!",
                    description: "The perfect Chocolate Fudge Cake covered in a creamy real chocolate buttercream. Two layers of buttery chocolate cake that sticks to your fork, paired with the ultimate chocolate frosting – heaven!",
                    image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?size=626&ext=jpg"
                },
                {
                    title: "It all started with a cookie.",
                    description: "A cookie is a baked or cooked snack or dessert that is typically small, flat and sweet",
                    image: "https://img.freepik.com/free-photo/pile-cookies-cloth-wooden-table_1150-19666.jpg?size=626&ext=jpg"
                },

            ],
            sideMenu: [
                "Pineapple pastry",
                "Chocolate cake",
                "Cookies"
            ]
        },
    }

    const { preference } = useSelector((state) => state.user.user);

    const [menu, setMenu] = useState([]);
    const [tagLine, setTagLine] = useState("")
    const [menuData, setMenuData] = useState([]);

    useEffect(() => {
        Object.keys(specials).map((key) => {
            if (key === preference) {
                setMenu(specials[key].sideMenu);
                setMenuData(specials[key].menuData);
                setTagLine(specials[key].tagLine)
            }
        }
        )
    }, [preference])

    return (
        <section id="specials" className="specials">
            <div className="container">

                <div className="section-title">
                    <h2>Check our <span>Specials</span></h2>
                    <p>{tagLine}</p>
                </div>

                <div className="row">
                    <div className="col-lg-3">
                        <ul className="nav nav-tabs flex-column">
                            {
                                menu?.map((data, index) => {
                                    return (
                                        <li className="nav-item">
                                            <a className={`nav-link ${index + 1 === 1 && "active"}`} data-toggle="tab" href={`#tab-${index + 1}`}>{data}</a>
                                        </li>
                                    )
                                })
                            }

                        </ul>
                    </div>
                    <div className="col-lg-9 mt-4 mt-lg-0">
                        <div className="tab-content">
                            {
                                menuData?.map((data, index) => {
                                    return (
                                        <div className={`tab-pane ${index + 1 === 1 && "active"}`} id={`tab-${index + 1}`}>
                                            <div className="row">
                                                <div className="col-lg-8 details order-2 order-lg-1">
                                                    <h3>{data.title}</h3>
                                                    <p className="fst-italic">{data.description}</p>
                                                </div>
                                                <div className="col-lg-4 text-center order-1 order-lg-2">
                                                    <img draggable={false} src={data.image} alt="" className="img-fluid" style={{ height: 160, width: 160, borderRadius: "100%", objectFit: "cover", backgroundPosition: "50% 50%", backgroundSize: "cover" }} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default Specials;
